import { Field } from 'ngx-angular-query-builder';
import { FieldMetadataCollectionBuilder, FilterOperators, FieldMetadataCollection, FilterFieldProvider } from '@common/filter/filtering';
import { asDate, mapDate, getMapCbk, ArrayToFilterListItemBuilder } from '@common/filter/services/array-to-filter-list-item-builder';
import { ITable, IRow, ITableColumn } from '@common/models/table';
import * as moment from 'moment';
import { sortFunc, getFilterFieldsFromColumns } from '@common/filter/filter-utils'
import { MojoWellKnownNames } from '@common/constants/mojo-well-known-names';


export class InvoiceStatusWidgetFilterFieldProvider implements FilterFieldProvider {


  private readonly fieldMetaDataCollection = new FieldMetadataCollection();

  constructor(
    private readonly tableData: ITable,
    private readonly product: string
  ) {

    const fieldMetaDataBuilder = new FieldMetadataCollectionBuilder(this.fieldMetaDataCollection);
    const optionBuilder = new ArrayToFilterListItemBuilder(tableData ? tableData.Rows : []);
    const sysOption = (s: string) => optionBuilder.forProperty(s, s, (x: IRow) => x[s]);

    optionBuilder.add('SystemInvoiceDate', (x: any) => asDate(x.SystemInvoiceDate), mapDate('SystemInvoiceDate'));

    sysOption('SystemInvoiceReference');
    sysOption('SystemPropertyReference');
    sysOption('SystemPropertyAddress');
    sysOption('SystemURN');
    sysOption('SystemNarrative');
    sysOption('SystemVatRate');
    sysOption('SystemNetAmount');
    sysOption('SystemVatAmount');
    sysOption('SystemGrossAmount');
    sysOption('SystemCurrency');
    sysOption('SystemCurrencyDescription');
    optionBuilder.add('SystemPaymentDueDate', (x: any) => asDate(x.SystemInvoiceDate), mapDate('SystemPaymentDueDate'));
    sysOption('SystemInvoiceStatus');
    sysOption('SystemPaymentStatus');
    sysOption('SystemPaymentDetails');
    sysOption('SystemDatePaid');
    sysOption('SystemAmountPaid');

    sysOption('SystemAccountNo');
    sysOption('SystemCreditorName');
    sysOption('CreditorFamiliarName');

    const options = optionBuilder.build();

    const addFilter = (label: string, optionsName: string, type: string, ops: string[]) => fieldMetaDataBuilder.add(label, optionsName, type, ops, options.get(optionsName));

    addFilter('Invoice Date', 'SystemInvoiceDate', 'date', FilterOperators.DateDefaults);
    addFilter('Invoice Reference', 'SystemInvoiceReference', 'string', FilterOperators.StringDefaults);
    addFilter('Property Reference', 'SystemPropertyReference', 'number', FilterOperators.Scalar);
    addFilter('Property Address', 'SystemPropertyAddress', 'string', FilterOperators.StringDefaults);
    addFilter('URN', 'SystemURN', 'number', FilterOperators.Scalar);
    addFilter('Narrative', 'SystemNarrative', 'string', FilterOperators.StringDefaults);
    addFilter('Vat Rate', 'SystemVatRate', 'number', FilterOperators.Scalar);
    addFilter('Net Amount', 'SystemNetAmount', 'number', FilterOperators.Scalar);
    addFilter('Vat Amount', 'SystemVatAmount', 'number', FilterOperators.Scalar);
    addFilter('Gross Amount', 'SystemGrossAmount', 'number', FilterOperators.Scalar);
    addFilter('Currency', 'SystemCurrency', 'string', FilterOperators.StringDefaults);
    addFilter('Currency Description', 'SystemCurrencyDescription', 'string', FilterOperators.StringDefaults);
    addFilter('Payment Due Date', 'SystemPaymentDueDate', 'date', FilterOperators.DateDefaults);
    addFilter('Invoice Status', 'SystemInvoiceStatus', 'string', FilterOperators.StringDefaults);
    addFilter('Payment Status', 'SystemPaymentStatus', 'string', FilterOperators.StringDefaults);
    addFilter('Date Paid', 'SystemDatePaid', 'date', FilterOperators.DateDefaults);
    addFilter('Amount Paid', 'SystemAmountPaid', 'number', FilterOperators.Scalar);

    if (product === MojoWellKnownNames.Products.MojoForSuppliers) {
      addFilter('Account No', 'SystemAccountNo', 'string', FilterOperators.StringDefaults);
    } else {
      addFilter('Creditor Account No', 'SystemAccountNo', 'string', FilterOperators.StringDefaults);
      addFilter('Mojo Form Ref', 'SystemMojoFormRef', 'string', FilterOperators.Scalar);
    }
    addFilter('Creditor Name', 'SystemCreditorName', 'string', FilterOperators.StringDefaults);
    addFilter('Creditor Familiar Name', 'CreditorFamiliarName', 'string', FilterOperators.StringDefaults);
  }

  getFilterFields(): Array<Field> {
    if (!this.tableData) return [];
    return getFilterFieldsFromColumns(this.fieldMetaDataCollection, this.tableData.Columns);
  }

  getFieldNameFromLabel(label: string): string {
    return this.fieldMetaDataCollection.getFieldNameFromLabel(label);
  }

  getFilterField(fieldName: string): Field {
    return this.fieldMetaDataCollection.getFilterField(fieldName);
  }

}
